<template>
  <div class="container bg-white rounded box-shadow-default">
    <div class="flex">
      <SmartIcon class="text-brand-secondary" :name="iconName" :size="2" />
      <SmartTitle
        class="ml-2"
        weight="medium"
        heading="3"
      >
        {{headerTitle}}
      </SmartTitle>
    </div>

    <SmartInput class="mt-3 bg-white" placeholder="Pesquisar..." v-model="search"/>

    <div class="items-container absolute" v-if="!isSearchingOnApi">
      <v-checkbox
        v-for="(item, index) in searchedList.length > 0 ? searchedList : itemListCopy"
        :key="itemKey ? item[itemKey] : item.id"
        :input-value="item.active"
        @change="setCheckValues(index)"
        :label="item[itemLabel]"
        color="#77bd4f"
        hide-details
      />
    </div>
    <Skeleton v-else />

    <div class="buttons-container flex justify-end absolute">
      <SmartButton
        class="mr-2"
        @click="clearAllSelections"
        :disabled="canClearSelections"
        tertiary
      >
        Limpar
      </SmartButton>
      <SmartButton
        @click="applySelections"
        :disabled="canApplySelections"
        tertiary
      >
        Aplicar
      </SmartButton>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SmartChechboxSearcher',
  components: {
    Skeleton: () => import('./Skeleton.vue')
  },
  props: {
    iconName: {
      type: String,
      required: true
    },
    headerTitle: {
      type: String,
      required: true
    },
    itemList: {
      type: Array,
      required: true
    },
    itemValue: {
      type: String,
      required: true
    },
    itemLabel: {
      type: String,
      required: true
    },
    itemKey: {
      type: String
    },
    searchableOnApi: {
      type: Boolean,
      default: false
    },
    actionName: {
      type: String
    },
    isSearchingOnApi: {
      type: Boolean,
      default: false
    },
    mutationName: {
      type: String
    }
  },
  data() {
    return {
      search: '',
      itemListCopy: [],
      searchedList: []
    };
  },
  watch: {
    itemList: {
      imediate: true,
      handler() {
        this.itemListCopy = this.itemList.map(item => ({
          ...item,
          active: false
        }));
      }
    },
    search(search) {
      if (search) {
        this.searchForItemLocally();
      } else {
        this.searchedList = [];
        if (this.actionName) {
          this.$emit('search-on-api',
            { search: '', actionName: this.actionName });
        }
      }
    }
  },
  computed: {
    selectedValues() {
      return this.itemListCopy.filter(item => item.active);
    },
    canApplySelections() {
      return !(this.itemListCopy.some(item => item.active));
    },
    canClearSelections() {
      return this.itemListCopy.every(item => !item.active);
    }
  },
  methods: {
    searchForItemOnApi() {
      this.$emit('search-on-api', {
        search: this.search,
        actionName: this.actionName
      });
    },
    searchForItemLocally() {
      this.searchedList = this.itemListCopy.filter(
        item => item[this.itemLabel].toLowerCase()
          .includes(this.search.toLowerCase())
      );

      if (this.searchedList.length > 0) { return this.searchedList; }

      return this.searchForItemOnApi();
    },
    setCheckValues(index) {
      const isItemActive = this.itemListCopy[index].active
        ? this.itemListCopy[index].active = false
        : this.itemListCopy[index].active = true;

      return isItemActive;
    },
    applySelections() {
      const checkboxValues = this.itemListCopy.filter(item => item.active);
      const searchParams = {
        checkboxValues,
        mutationName: this.mutationName
      };
      this.$emit('set-filter', searchParams);
    },
    clearAllSelections() {
      this.itemListCopy.forEach((item) => { item.active = false; });
      this.$emit('set-filter', { searchParams: {} });
    },
    awaySelf() {

    }
  }
};
</script>

<style lang="scss" scoped>

.container {
  z-index: 10;
  width: 20rem;
  height: 18rem;
  padding: 2.2rem 1.6rem;
}

.items-container {
  height: 6rem;
  border-radius: 0.4rem;

  width: 16rem;
  right: 2rem;
  top: 7rem;
  padding: 0.3rem;

  z-index: -1;
  border: 1px solid rgba(115, 115, 115, 0.56);
  overflow: scroll;
}

.buttons-container {
  bottom: 1.3rem;
  width: 16rem;
}
</style>
